import { Env } from "@stencil/core";
import { APP_DIRECTORY_PRODUCT_ID, DASHBOARD_PRODUCT_ID } from "../constants";
import { DropdownItem } from "../components/common-header/dropdown-list/dropdown-list";

const createDropdownOption = (href: string, text: string, productId: string): DropdownItem => ({
    href,
    text,
    type: "product",
    value: productId,
    valueObject: {
        ProductId: productId
    }
});


export const DASHBOARD_OPTION = createDropdownOption(
    Env.USER_DASHBOARD_URL,
    "Home",
    DASHBOARD_PRODUCT_ID
);

export const APP_DIRECTORY_OPTION = createDropdownOption(
    Env.GLOBAL_APP_DIRECTORY_URL,
    "App Directory",
    APP_DIRECTORY_PRODUCT_ID
);

const isProduct = (item: any, productId: string): boolean =>
    item?.valueObject?.ProductId === productId || item?.value === productId;

export const IS_DASHBOARD = ({ item }: { item: any }) =>
    isProduct(item, DASHBOARD_PRODUCT_ID);

export const IS_APP_DIRECTORY = ({ item }: { item: any }) =>
    isProduct(item, APP_DIRECTORY_PRODUCT_ID);
